import {
  GET_WORKER_OUTREACH,
  UPDATE_OUTREACH_STATUS,
} from '../../config/graphQL/documentNode/shiftClaimDocuments';
import {OutreachShift} from '../types/shiftClaim';
import {gqlService} from '../../config/graphQL';

export async function fetchAvailableShifts(
  wuserId: string,
): Promise<OutreachShift[]> {
  const res = await gqlService?.query<{getWorkerOutreach: OutreachShift[]}>({
    query: GET_WORKER_OUTREACH,
    fetchPolicy: 'network-only',
    variables: {wiwUserId: wuserId},
  });
  return res?.data?.getWorkerOutreach ?? [];
}

export async function claimShift(entityId: string): Promise<void> {
  await gqlService?.mutation({
    mutation: UPDATE_OUTREACH_STATUS,
    fetchPolicy: 'network-only',
    variables: {entityId, status: 'accepted'},
  });
}

export async function rejectShift(
  entityId: string,
  status: string,
): Promise<void> {
  await gqlService?.mutation({
    mutation: UPDATE_OUTREACH_STATUS,
    fetchPolicy: 'network-only',
    variables: {entityId, status},
  });
}
